export function allowOnlyNumbeAndSpace(input) {
	let regOnlyNum = /^[\d ]*$/;
	return regOnlyNum.test(input);
}
export function checkIdNumber(input) {
	// idNumber
	let regIdNum = /^(?!-)(?!\s)[0-9a-zA-Z\s-]*$/g;
	return regIdNum.test(input);
}
export function checkPositiveNumber(input) {
	let number = Number(input);
	return number >= 0 ? true : false;
}
export function checkExtraFormInput(input, name) {
	switch (name) {
		// EFT Ambria
		case 'account_number': {
			return allowOnlyNumbeAndSpace(input);
		}
		case 'financial_institution': {
			return checkPositiveNumber(input) && input.length < 4
				? true
				: false;
		}
		case 'branch_number': {
			return checkPositiveNumber(input) && input.length < 6
				? true
				: false;
		}
		// Customer extra form
		case 'price_1':
		case 'price_2': {
			return checkPositiveNumber(input);
		}
		default: {
			return true;
		}
	}
}
